import { shopManagerApi } from 'configs';
import api from 'configs/api';
import { convertToSearchCriteria } from 'helpers/api';

import {
  getQuoteCustomersGridStart,
  getQuoteCustomersGridSuccess,
  getQuoteCustomersGridFailed,
  createQuoteProCustomerStart,
  createQuoteProCustomerSuccess,
  createQuoteProCustomerFailed,
  getQuoteProProductsStart,
  getQuoteProProductsSuccess,
  getQuoteProProductsFailed,
  getQuoteProProductsBySearchCriteriaStart,
  getQuoteProProductsBySearchCriteriaSuccess,
  getQuoteProProductsBySearchCriteriaFailed,
  getQuoteProductStart,
  getQuoteProductSuccess,
  getQuoteProductFailed,
  getQuoteProGroupsAttributeStart,
  getQuoteProGroupsAttributeSuccess,
  getQuoteProGroupsAttributeFailed,
  updateQuoteProGroupsAttributeStart,
  updateQuoteProGroupsAttributeSuccess,
  updateQuoteProGroupsAttributeFailed,
  updateQuoteProListingStart,
  updateQuoteProListingSuccess,
  updateQuoteProListingFailed,
  getQuoteProQuotesApiStart,
  getQuoteProQuotesApiSuccess,
  getQuoteProQuotesApiFailed,
  addItemsToQuoteStart,
  addItemsToQuoteSuccess,
  addItemsToQuoteFailed,
  deleteQuoteItemStart,
  deleteQuoteItemSuccess,
  deleteQuoteItemFailed,
  convertQuoteStart,
  convertQuoteSuccess,
  convertQuoteFailed,
  getQuoteItemsCombinedStart,
  getQuoteItemsCombinedSuccess,
  getQuoteItemsCombinedFailed,
  getQuoteTotalsStart,
  getQuoteTotalsSuccess,
  getQuoteTotalsFailed,
  openCheckoutStart,
  openCheckoutSuccess,
  openCheckoutFailed,
  getQuoteCartBillingAddressStart,
  getQuoteCartBillingAddressSuccess,
  getQuoteCartBillingAddressFailed,
  setQuoteCartBillingAddressStart,
  setQuoteCartBillingAddressSuccess,
  setQuoteCartBillingAddressFailed,
  getQuoteCartShippingAddressStart,
  getQuoteCartShippingAddressSuccess,
  getQuoteCartShippingAddressFailed,
  setQuoteCartShippingAddressStart,
  setQuoteCartShippingAddressSuccess,
  setQuoteCartShippingAddressFailed,
  getQuoteCartPaymentsMethodsStart,
  getQuoteCartPaymentsMethodsSuccess,
  getQuoteCartPaymentsMethodsFailed,
  getQuoteCartShippingMethodsStart,
  getQuoteCartShippingMethodsSuccess,
  getQuoteCartShippingMethodsFailed,
  getQuoteCartSelectedShippingMethodStart,
  getQuoteCartSelectedShippingMethodSuccess,
  getQuoteCartSelectedShippingMethodFailed,
  setQuoteCartShippingMethodStart,
  setQuoteCartShippingMethodSuccess,
  setQuoteCartShippingMethodFailed,
  quoteProPlaceOrderCombinedStart,
  quoteProPlaceOrderCombinedSuccess,
  quoteProPlaceOrderCombinedFailed,
  getQuoteProTermsAndConditionsStart,
  getQuoteProTermsAndConditionsSuccess,
  getQuoteProTermsAndConditionsFailed,
  getTermsAndConditionsListStart,
  getTermsAndConditionsListSuccess,
  getTermsAndConditionsListFailed,
  deleteTermsAndConditionsStart,
  deleteTermsAndConditionsSuccess,
  deleteTermsAndConditionsFailed,
  saveTermsAndConditionsStart,
  saveTermsAndConditionsSuccess,
  saveTermsAndConditionsFailed,
  getTouchmdActivityStart,
  getTouchmdActivitySuccess,
  getTouchmdActivityFailed,
  getQuoteProductSubscriptionOptionsStart,
  getQuoteProductSubscriptionOptionsSuccess,
  getQuoteProductSubscriptionOptionsFailed,
  deleteQuoteProductSubscriptionOptionStart,
  deleteQuoteProductSubscriptionOptionSuccess,
  deleteQuoteProductSubscriptionOptionFailed,
  updateQuoteProductSubscriptionOptionStart,
  updateQuoteProductSubscriptionOptionSuccess,
  updateQuoteProductSubscriptionOptionFailed,
  getQuoteProAttributeDataStart,
  getQuoteProAttributeDataSuccess,
  getQuoteProAttributeDataFailed,
  getCustomerPushCartStart,
  getCustomerPushCartSuccess,
  getCustomerPushCartFailed,
  createCustomerPushCartStart,
  createCustomerPushCartSuccess,
  createCustomerPushCartFailed,
  updateCustomerPushCartStart,
  updateCustomerPushCartSuccess,
  updateCustomerPushCartFailed,
  publishPushCartItemsStart,
  publishPushCartItemsSuccess,
  publishPushCartItemsFailed,
  createPatientsGroupQuoteStart,
  createPatientsGroupQuoteSuccess,
  createPatientsGroupQuoteFailed,
  createActiveCartCombinedStart,
  createActiveCartCombinedSuccess,
  createActiveCartCombinedFailed,
  getQuoteCustomerDataStart,
  getQuoteCustomerDataSuccess,
  getQuoteCustomerDataFailed,
  updateQuoteCustomerDataStart,
  updateQuoteCustomerDataSuccess,
  updateQuoteCustomerDataFailed,
  getCustomerSubscriptionsStart,
  getCustomerSubscriptionsSuccess,
  getCustomerSubscriptionsFailed,
  getCustomerAmastyQuotesApiStart,
  getCustomerAmastyQuotesApiSuccess,
  getCustomerAmastyQuotesApiFailed,
  createQuoteProPackageStart,
  createQuoteProPackageSuccess,
  createQuoteProPackageFailed,
  getQuoteProPackagesStart,
  getQuoteProPackagesSuccess,
  getQuoteProPackagesFailed,
  deleteQuoteProPackageStart,
  deleteQuoteProPackageSuccess,
  deleteQuoteProPackageFailed,
  publishPushCartTreatmentsStart,
  publishPushCartTreatmentsSuccess,
  publishPushCartTreatmentsFailed,
  getTimezoneConfigStart,
  getTimezoneConfigSuccess,
  getTimezoneConfigFailed,
  createQuotePdfPreviewStart,
  createQuotePdfPreviewSuccess,
  createQuotePdfPreviewFailed,
  createDraftQuotePdfPreviewStart,
  createDraftQuotePdfPreviewSuccess,
  createDraftQuotePdfPreviewFailed,
  createRecentQuotePdfPreviewStart,
  createRecentQuotePdfPreviewSuccess,
  createRecentQuotePdfPreviewFailed,
  downloadDraftQuotePdfStart,
  downloadDraftQuotePdfSuccess,
  downloadDraftQuotePdfFailed,
  downloadRecentQuotePdfStart,
  downloadRecentQuotePdfSuccess,
  downloadRecentQuotePdfFailed,
  createDraftQuoteStart,
  createDraftQuoteSuccess,
  createDraftQuoteFailed,
  getDraftQuotesByCustomerStart,
  getDraftQuotesByCustomerSuccess,
  getDraftQuotesByCustomerFailed,
  openCheckoutServiceForDraftedQuoteStart,
  openCheckoutServiceForDraftedQuoteSuccess,
  openCheckoutServiceForDraftedQuoteFailed,
  publishDraftQuoteByIdStart,
  publishDraftQuoteByIdSuccess,
  publishDraftQuoteByIdFailed,
  updateDraftQuoteByIdStart,
  updateDraftQuoteByIdSuccess,
  updateDraftQuoteByIdFailed,
  downloadQuotePdfStart,
  downloadQuotePdfSuccess,
  downloadQuotePdfFailed,
  getDealTasksStart,
  getDealTasksSuccess,
  getDealTasksFailed,
  createDealTaskStart,
  createDealTaskSuccess,
  createDealTaskFailed,
  updateDealTaskStart,
  updateDealTaskSuccess,
  updateDealTaskFailed,
  deleteDealTaskStart,
  deleteDealTaskSuccess,
  deleteDealTaskFailed,
  getDealActivitiesStart,
  getDealActivitiesSuccess,
  getDealActivitiesFailed,
  createDealActivityStart,
  createDealActivitySuccess,
  createDealActivityFailed,
  updateDealActivityStart,
  updateDealActivitySuccess,
  updateDealActivityFailed,
  deleteDeAlactivityStart,
  deleteDealActivitySuccess,
  deleteDealActivityFailed,
  getMarketingSegmentsQuoteQueueStart,
  getMarketingSegmentsQuoteQueueSuccess,
  getMarketingSegmentsQuoteQueueFailed,
  getFailedMarketingSegmentsQuoteQueueStart,
  getFailedMarketingSegmentsQuoteQueueSuccess,
  getFailedMarketingSegmentsQuoteQueueFailed,
  deleteFailedMarketingSegmentQueueTasksFailed,
  deleteFailedMarketingSegmentQueueTasksStart,
  deleteFailedMarketingSegmentQueueTasksSuccess,
  deleteMarketingSegmentQueueTaskStart,
  deleteMarketingSegmentQueueTaskSuccess,
  deleteMarketingSegmentQueueTaskFailed,
  getAllTasksStart,
  getAllTasksSuccess,
  getAllTasksFailed,
  getAllActivitiesStart,
  getAllActivitiesSuccess,
  getAllActivitiesFailed,
  getQuoteProProductsExportStart,
  getQuoteProProductsExportSuccess,
  getQuoteProProductsExportFailed,
  cancelQuoteStart,
  cancelQuoteSuccess,
  cancelQuoteFailed
} from 'redux/actions/quote';

//Combined API methods
export const getQuoteItemsCombinedApi = async ({
  dispatch,
  sortDirection,
  sortField,
  pageSize,
  currentPage,
  searchConditions,
  filterConditions,
  customerId
}) => {
  try {
    const params = convertToSearchCriteria({
      searchConditions,
      filterConditions,
      pageSize,
      currentPage,
      sortField,
      sortDirection
    });

    dispatch(getQuoteItemsCombinedStart());
    const { data: activeQuotes } = await api.get(`${shopManagerApi}/quotepro-store/quotes?${params}`);

    if (activeQuotes?.items?.length) {
      const { data: activeQuoteItems } = await api.get(`${shopManagerApi}/quotepro-store/carts/${activeQuotes.items[0].id}/items`);
      const customerData = {...activeQuotes.items[0], items: activeQuoteItems.items};
      dispatch(getQuoteItemsCombinedSuccess(customerData));
      return customerData;
    }

    await api.post(`${shopManagerApi}/quotepro-store/quotes/create/${customerId}`);
    // TODO: rework response from API with customer data for new created quote
    //redo after https://dermpro.atlassian.net/browse/SM-3212
    const { data: activeQuotesData } = await api.get(`${shopManagerApi}/quotepro-store/quotes?${params}`);
    dispatch(getQuoteItemsCombinedSuccess(activeQuotesData.items[0]));
    return activeQuotesData.items[0];
  } catch (e) {
    dispatch(getQuoteItemsCombinedFailed(e));
    return null;
  }
};

export const getCustomerAmastyQuotesApi = async ({
  dispatch,
  searchConditions,
  filterConditions,
  pageSize,
  currentPage,
  sortField,
  sortDirection
}) => {
  try {
    dispatch(getCustomerAmastyQuotesApiStart());

    const params = convertToSearchCriteria({
      searchConditions,
      filterConditions,
      pageSize,
      currentPage,
      sortField,
      sortDirection
    });

    const { data: { items: {items: amastyData, total_count} } } = await api.get(`${shopManagerApi}/quotepro-store/amasty-quotes?${params}`);

    dispatch(getCustomerAmastyQuotesApiSuccess(amastyData, total_count));
  } catch (e) {
    dispatch(getCustomerAmastyQuotesApiFailed(e));
  }
};

// TODO: create API for this, create quote for pay from shopmanager, after paid successfully need to split/update pushcart
export const createActiveCartCombinedAPI = async ({dispatch, customerId, selectedItems, quoteDiscount}) => {
  try {
    dispatch(createActiveCartCombinedStart());
    const {data: {cartId}} = await api.post(`${shopManagerApi}/quotepro-store/quotes/create/${customerId}`);
    const { data: {procedure} } = await api.post(`${shopManagerApi}/quotepro-store/carts/${cartId}/items`, { cartItems: selectedItems, quoteDiscount });
    const params = convertToSearchCriteria({
      sortDirection: 'desc',
      sortField: 'customer_id',
      pageSize: 1,
      currentPage: 1,
      filterConditions: [
        {
          field: 'main_table.entity_id',
          value: cartId,
          conditionType: 'eq'
        }
      ],
      searchConditions: []
    });
    const {data} = await api.get(`${shopManagerApi}/quotepro-store/quotes?${params}`);
    const cartData = {...data?.items[0], items: procedure};
    dispatch(createActiveCartCombinedSuccess(cartData));
    return cartId;
  } catch (e) {
    dispatch(createActiveCartCombinedFailed(e));
    return null;
  }
};

export const quoteProPlaceOrderCombinedApi = async ({dispatch, quoteId, orderData, isShippingAvailable}) => {
  try {
    dispatch(quoteProPlaceOrderCombinedStart());
    const {
      shippingAddress,
      billingAddress,
      paymentData
    } = orderData;

    if (isShippingAvailable) {
      const address = shippingAddress.same_as_billing ? billingAddress : shippingAddress;
      await api.post(`${shopManagerApi}/quotepro-store/carts/${quoteId}/shipping-address`, address);
    }

    await api.post(`${shopManagerApi}/quotepro-store/carts/${quoteId}/billing-address`, billingAddress);
    await api.put(`${shopManagerApi}/quotepro-store/carts/${quoteId}/order`, paymentData);
    dispatch(quoteProPlaceOrderCombinedSuccess());
    return true;
  } catch (e) {
    dispatch(quoteProPlaceOrderCombinedFailed(e));
    return false;
  }
};

//Single API methods
export const getQuoteCustomersGridApi = async ({
  dispatch,
  sortDirection,
  sortField,
  pageSize,
  currentPage,
  searchConditions,
  filterConditions
}) => {
  try {
    dispatch(getQuoteCustomersGridStart());
    const params = convertToSearchCriteria({
      searchConditions,
      filterConditions,
      pageSize,
      currentPage,
      sortField,
      sortDirection
    });
    const { data } = await api.get(`${shopManagerApi}/store/customers?${params}`);
    dispatch(getQuoteCustomersGridSuccess(data));
  } catch (e) {
    dispatch(getQuoteCustomersGridFailed(e));
  }
};

export const getQuoteCustomerDataApi = async ({dispatch, id}) => {
  try {
    dispatch(getQuoteCustomerDataStart());
    const { data } = await api.get(`${shopManagerApi}/quotepro-store/customer/${id}`);
    dispatch(getQuoteCustomerDataSuccess(data));
  } catch (e) {
    dispatch(getQuoteCustomerDataFailed(e));
  }
};

export const updateQuoteCustomerDataApi = async ({dispatch, customerId, customerData}) => {
  try {
    dispatch(updateQuoteCustomerDataStart());
    const {data} = await api.put(`${shopManagerApi}/quotepro-store/customer/${customerId}`, customerData);
    dispatch(updateQuoteCustomerDataSuccess(data));
    return true;
  } catch (e) {
    dispatch(updateQuoteCustomerDataFailed(e));
    return false;
  }
};

export const createQuoteProCustomerApi = async ({dispatch, customer}) => {
  try {
    dispatch(createQuoteProCustomerStart());
    const {data} = await api.post(`${shopManagerApi}/quotepro-store/customer`, {customer});
    dispatch(createQuoteProCustomerSuccess(data));
    return true;
  } catch (e) {
    dispatch(createQuoteProCustomerFailed(e));
    return false;
  }
};

export const getQuoteProProductsApi = async ({dispatch}) => {
  try {
    dispatch(getQuoteProProductsStart());
    const { data } = await api.get(`${shopManagerApi}/quotepro-store/product?limit=1500`);
    dispatch(getQuoteProProductsSuccess(data));
  } catch (e) {
    dispatch(getQuoteProProductsFailed(e));
  }
};

export const getQuoteProProductsBySearchCriteriaApi = async ({
  dispatch,
  sortDirection,
  sortField,
  pageSize,
  currentPage,
  searchConditions,
  filterConditions
}) => {
  try {
    dispatch(getQuoteProProductsBySearchCriteriaStart());
    const params = convertToSearchCriteria({
      sortDirection,
      sortField,
      pageSize,
      currentPage,
      filterConditions,
      searchConditions
    });
    const { data } = await api.get(`${shopManagerApi}/quotepro-store/product/searchcriteria?${params}`);
    dispatch(getQuoteProProductsBySearchCriteriaSuccess(data));
  } catch (e) {
    dispatch(getQuoteProProductsBySearchCriteriaFailed(e));
  }
};

export const getQuoteProductApi = async ({dispatch, sku}) => {
  try {
    dispatch(getQuoteProductStart());
    const { data: {product} } = await api.get(`${shopManagerApi}/quotepro-store/product/${sku}`);
    dispatch(getQuoteProductSuccess(product));
  } catch (e) {
    dispatch(getQuoteProductFailed(e));
  }
};

export const getQuoteProStoreProductExportApi = async ({ dispatch }) => {
  try {
    dispatch(getQuoteProProductsExportStart());
    const { data } = await api.get(`${shopManagerApi}/quotepro-store/export/products`);
    dispatch(getQuoteProProductsExportSuccess(data));
  } catch (e) {
    dispatch(getQuoteProProductsExportFailed(e));
  }
};

export const getQuoteProGroupsAttributeApi = async ({dispatch}) => {
  try {
    dispatch(getQuoteProGroupsAttributeStart());
    const { data } = await api.get(`${shopManagerApi}/quotepro-store/product/attributes/catalog_quotepro_groups`);
    dispatch(getQuoteProGroupsAttributeSuccess(data.attribute));
  } catch (e) {
    dispatch(getQuoteProGroupsAttributeFailed(e));
  }
};

export const updateQuoteProGroupsAttributeApi = async ({dispatch, attribute, groupsToDelete}) => {
  try {
    dispatch(updateQuoteProGroupsAttributeStart());

    //delete all groupsToDelete before update to have correct response without deleted items
    if (!!groupsToDelete.length) {
      const promises = groupsToDelete.map((id) => api.delete(
        `${shopManagerApi}/quotepro-store/product/attributes/catalog_quotepro_groups/options/${id}`
      ));
      await Promise.all(promises);
    }

    const { data } = await api.post(`${shopManagerApi}/quotepro-store/products/attribute`, {attribute});
    dispatch(updateQuoteProGroupsAttributeSuccess(data.attribute));
  } catch (e) {
    dispatch(updateQuoteProGroupsAttributeFailed(e));
  }
};

export const updateQuoteProListingApi = async ({dispatch, product}) => {
  try {
    dispatch(updateQuoteProListingStart());
    const { data } = await api.patch(`${shopManagerApi}/quotepro-store/products`, {product});
    dispatch(updateQuoteProListingSuccess(data));
  } catch (e) {
    dispatch(updateQuoteProListingFailed(e));
  }
};

export const getTouchmdActivityApi = async ({dispatch, email, page = 1, limit = 20}) => {
  try {
    dispatch(getTouchmdActivityStart());
    const { data } = await api.get(`${shopManagerApi}/touchmd/api/patient-actions?email=${email}&page=${page}&limit=${limit}`);
    dispatch(getTouchmdActivitySuccess(data));
  } catch (e) {
    dispatch(getTouchmdActivityFailed(e));
  }
};

export const getQuoteProQuotesApi = async ({
  dispatch,
  sortDirection,
  sortField,
  pageSize,
  currentPage,
  searchConditions,
  filterConditions,
  isSetUserActiveQuote = false
}) => {
  try {
    const params = convertToSearchCriteria({
      searchConditions,
      filterConditions,
      pageSize,
      currentPage,
      sortField,
      sortDirection
    });

    dispatch(getQuoteProQuotesApiStart());
    const { data } = await api.get(`${shopManagerApi}/quotepro-store/quotes?${params}`);
    dispatch(getQuoteProQuotesApiSuccess(data, isSetUserActiveQuote));
    return data;
  } catch (e) {
    dispatch(getQuoteProQuotesApiFailed(e));
    return null;
  }
};

export const addItemsToQuoteApi = async ({dispatch, cartId, cartItems}) => {
  try {
    dispatch(addItemsToQuoteStart());
    const { data } = await api.post(`${shopManagerApi}/quotepro-store/carts/${cartId}/items`, [cartItems]);
    dispatch(addItemsToQuoteSuccess(data));
    return true;
  } catch (e) {
    dispatch(addItemsToQuoteFailed(e));
    return false;
  }
};

export const deleteQuoteItemApi = async ({dispatch, cartId, itemId}) => {
  try {
    dispatch(deleteQuoteItemStart());
    await api.delete(`${shopManagerApi}/quotepro-store/carts/${cartId}/items/${itemId}`);
    dispatch(deleteQuoteItemSuccess(itemId));
    return true;
  } catch (e) {
    dispatch(deleteQuoteItemFailed(e));
    return false;
  }
};

export const convertQuoteApi = async ({dispatch, quote}) => {
  try {
    dispatch(convertQuoteStart());
    const { data } = await api.post(`${shopManagerApi}/quotepro-store/carts/convert`, quote);
    dispatch(convertQuoteSuccess(data));
    return true;
  } catch (e) {
    dispatch(convertQuoteFailed(e));
    return false;
  }
};

export const getQuoteTotalsApi = async ({dispatch, quoteId}) => {
  try {
    dispatch(getQuoteTotalsStart());
    const { data } = await api.get(`${shopManagerApi}/quotepro-store/carts/${quoteId}/totals`);
    dispatch(getQuoteTotalsSuccess(data));
    return true;
  } catch (e) {
    dispatch(getQuoteTotalsFailed(e));
    return false;
  }
};

export const openCheckoutServiceApi = async ({dispatch, email, pushCartId}) => {
  try {
    dispatch(openCheckoutStart());
    const paramsObj = {
      email,
      pushCartId
    };

    const params = new URLSearchParams(paramsObj).toString();

    const { data } = await api.post(`${shopManagerApi}/checkout?${params}`);
    dispatch(openCheckoutSuccess(data));
  } catch (e) {
    dispatch(openCheckoutFailed(e));
  }
};

export const getQuoteCartBillingAddressApi = async ({dispatch, quoteId}) => {
  try {
    dispatch(getQuoteCartBillingAddressStart());
    const { data } = await api.get(`${shopManagerApi}/quotepro-store/carts/${quoteId}/billing-address`);
    dispatch(getQuoteCartBillingAddressSuccess(data));
    return true;
  } catch (e) {
    dispatch(getQuoteCartBillingAddressFailed(e));
    return false;
  }
};

export const setQuoteCartBillingAddressApi = async ({dispatch, quoteId, billingAddress}) => {
  try {
    dispatch(setQuoteCartBillingAddressStart());
    const { data } = await api.post(`${shopManagerApi}/quotepro-store/carts/${quoteId}/billing-address`, billingAddress);
    dispatch(setQuoteCartBillingAddressSuccess(data));
    return true;
  } catch (e) {
    dispatch(setQuoteCartBillingAddressFailed(e));
    return false;
  }
};

export const getQuoteCartShippingAddressApi = async ({dispatch, quoteId}) => {
  try {
    dispatch(getQuoteCartShippingAddressStart());
    const { data } = await api.get(`${shopManagerApi}/quotepro-store/carts/${quoteId}/shipping-address`);
    dispatch(getQuoteCartShippingAddressSuccess(data));
    return true;
  } catch (e) {
    dispatch(getQuoteCartShippingAddressFailed(e));
    return false;
  }
};

export const setQuoteCartShippingAddressApi = async ({dispatch, quoteId, shippingAddress}) => {
  try {
    dispatch(setQuoteCartShippingAddressStart());
    await api.post(`${shopManagerApi}/quotepro-store/carts/${quoteId}/shipping-address`, shippingAddress);
    dispatch(setQuoteCartShippingAddressSuccess());
    return true;
  } catch (e) {
    dispatch(setQuoteCartShippingAddressFailed(e));
    return false;
  }
};

export const getQuoteCartPaymentsMethodsApi = async ({dispatch, quoteId}) => {
  try {
    dispatch(getQuoteCartPaymentsMethodsStart());
    const { data } = await api.get(`${shopManagerApi}/quotepro-store/carts/${quoteId}/payment-methods`);
    dispatch(getQuoteCartPaymentsMethodsSuccess(data));
    return true;
  } catch (e) {
    dispatch(getQuoteCartPaymentsMethodsFailed(e));
    return false;
  }
};

export const getQuoteCartShippingMethodsApi = async ({dispatch, quoteId, shippingAddress}) => {
  try {
    dispatch(getQuoteCartShippingMethodsStart());
    const { data } = await api.post(`${shopManagerApi}/quotepro-store/carts/${quoteId}/estimate-shipping-methods`, shippingAddress);
    dispatch(getQuoteCartShippingMethodsSuccess(data));
    return data;
  } catch (e) {
    dispatch(getQuoteCartShippingMethodsFailed(e));
    return [];
  }
};

export const getQuoteCartSelectedShippingMethodApi = async ({dispatch, quoteId}) => {
  try {
    dispatch(getQuoteCartSelectedShippingMethodStart());
    const { data } = await api.get(`${shopManagerApi}/quotepro-store/carts/${quoteId}/shipping-method`);
    dispatch(getQuoteCartSelectedShippingMethodSuccess(data));
  } catch (e) {
    dispatch(getQuoteCartSelectedShippingMethodFailed(e));
  }
};

export const setQuoteCartShippingMethodApi = async ({dispatch, quoteId, shippingMethod}) => {
  try {
    dispatch(setQuoteCartShippingMethodStart());
    await api.post(`${shopManagerApi}/quotepro-store/carts/${quoteId}/shipping-method`, shippingMethod);
    dispatch(setQuoteCartShippingMethodSuccess());
    return true;
  } catch (e) {
    dispatch(setQuoteCartShippingMethodFailed(e));
    return false;
  }
};

export const getQuoteProTermsAndConditionsApi = async ({dispatch, quoteId}) => {
  try {
    dispatch(getQuoteProTermsAndConditionsStart());
    const { data } = await api.get(`${shopManagerApi}/quotepro-store/carts/${quoteId}/licence`);
    dispatch(getQuoteProTermsAndConditionsSuccess(data));
  } catch (e) {
    dispatch(getQuoteProTermsAndConditionsFailed(e));
  }
};

export const getTermsAndConditionsListAPI = async ({ dispatch }) => {
  try {
    dispatch(getTermsAndConditionsListStart());
    const { data } = await api.get(`${shopManagerApi}/quotepro-store/carts/licence`);
    dispatch(getTermsAndConditionsListSuccess(data));
  } catch (e) {
    dispatch(getTermsAndConditionsListFailed(e));
  }
};

export const saveTermsAndConditionsAPI = async ({ dispatch, agreement }) => {
  try {
    dispatch(saveTermsAndConditionsStart());
    const requestData = { data: agreement };
    const data = await api.post(`${shopManagerApi}/quotepro-store/carts/licence/`, requestData);
    dispatch(saveTermsAndConditionsSuccess(data));
  } catch (e) {
    dispatch(saveTermsAndConditionsFailed(e));
  }
};

export const deleteTermsAndConditionsAPI = async ({ dispatch, id }) => {
  try {
    dispatch(deleteTermsAndConditionsStart());
    await api.delete(`${shopManagerApi}/quotepro-store/carts/licence/${id}`);
    dispatch(deleteTermsAndConditionsSuccess(id));
  } catch (e) {
    dispatch(deleteTermsAndConditionsFailed());
  }
};

export const getQuoteProductSubscriptionOptionsApi = async ({dispatch, sku}) => {
  try {
    dispatch(getQuoteProductSubscriptionOptionsStart());
    const { data } = await api.get(`${shopManagerApi}/quotepro-store/product/subscription/${sku}`);
    dispatch(getQuoteProductSubscriptionOptionsSuccess(data, sku));
  } catch (e) {
    dispatch(getQuoteProductSubscriptionOptionsFailed(e));
  }
};

export const deleteQuoteProductSubscriptionOptionApi = async ({dispatch, id}) => {
  try {
    dispatch(deleteQuoteProductSubscriptionOptionStart());
    await api.delete(`${shopManagerApi}/quotepro-store/product/subscription/${id}`);
    dispatch(deleteQuoteProductSubscriptionOptionSuccess(id));
  } catch (e) {
    dispatch(deleteQuoteProductSubscriptionOptionFailed(e));
  }
};

export const updateQuoteProductSubscriptionOptionApi = async ({dispatch, subscriptions, isNewOptions}) => {
  try {
    dispatch(updateQuoteProductSubscriptionOptionStart());
    let subscriptionsResult = [];

    // TODO: remove the condition if it is possible
    if (isNewOptions) {
      subscriptionsResult = await Promise.all(
        subscriptions.map((option) => api.patch(`${shopManagerApi}/quotepro-store/product/subscription`, {interval: option}))
      );
    } else {
      subscriptionsResult = await api.patch(`${shopManagerApi}/quotepro-store/product/subscription`, {interval: subscriptions});
    }

    dispatch(updateQuoteProductSubscriptionOptionSuccess(subscriptionsResult, isNewOptions));
  } catch (e) {
    dispatch(updateQuoteProductSubscriptionOptionFailed(e));
  }
};

export const getQuoteProAttributeDataApi = async ({dispatch, attributeCode}) => {
  try {
    dispatch(getQuoteProAttributeDataStart());
    const { data } = await api.get(`${shopManagerApi}/quotepro-store/product/attributes/${attributeCode}`);
    dispatch(getQuoteProAttributeDataSuccess(data.attribute, attributeCode));
  } catch (e) {
    dispatch(getQuoteProAttributeDataFailed(e));
  }
};

export const getCustomerPushCartApi = async ({dispatch, customerId}) => {
  try {
    dispatch(getCustomerPushCartStart());
    const {data} = await api.get(`${shopManagerApi}/push-cart/customer/${customerId}`);
    dispatch(getCustomerPushCartSuccess(data));
    return data;
  } catch (e) {
    dispatch(getCustomerPushCartFailed(e));
    return null;
  }
};

export const createCustomerPushCartApi = async ({dispatch, pushCart}) => {
  try {
    dispatch(createCustomerPushCartStart());
    const {data} = await api.post(`${shopManagerApi}/push-cart`, pushCart);
    dispatch(createCustomerPushCartSuccess(data));
    return true;
  } catch (e) {
    dispatch(createCustomerPushCartFailed(e));
    return false;
  }
};

export const updateCustomerPushCartApi = async ({dispatch, pushCartId, pushCart}) => {
  try {
    dispatch(updateCustomerPushCartStart());
    const {data} = await api.patch(`${shopManagerApi}/push-cart/${pushCartId}`, pushCart);
    dispatch(updateCustomerPushCartSuccess(data));
    return data.pushCart;
  } catch (e) {
    dispatch(updateCustomerPushCartFailed(e));
    return null;
  }
};

export const publishPushCartItemsApi = async ({dispatch, pushCartId, publishData}) => {
  try {
    dispatch(publishPushCartItemsStart());
    const {data} = await api.post(`${shopManagerApi}/push-cart/${pushCartId}/publish`, publishData);
    // TODO: looks like we don't need to check the pushcart status
    const pushCart = data.pushCart.status === 'PUBLISHED' ? null : data.pushCart;
    dispatch(publishPushCartItemsSuccess(pushCart));
    return !!pushCart && !!pushCart.selectedItems.length;
  } catch (e) {
    dispatch(publishPushCartItemsFailed(e));
    return false;
  }
};

export const publishPushCartTreatmentsApi = async ({
  dispatch,
  pushCartId,
  publishData
}) => {
  try {
    dispatch(publishPushCartTreatmentsStart());
    const {data} = await api.post(`${shopManagerApi}/push-cart/${pushCartId}/publish-treatments`, publishData);
    dispatch(publishPushCartTreatmentsSuccess(data));
    return true;
  } catch (e) {
    dispatch(publishPushCartTreatmentsFailed(e));
    return false;
  }
};

export const createPatientsGroupQuoteApi = async ({dispatch, id, publishData}) => {
  try {
    dispatch(createPatientsGroupQuoteStart());
    await api.post(`${shopManagerApi}/quotepro-store/marketing-segments/queue/${id}`, publishData);
    dispatch(createPatientsGroupQuoteSuccess(publishData));
    return true;
  } catch (e) {
    dispatch(createPatientsGroupQuoteFailed(e));
    return false;
  }
};

export const getMarketingSegmentsQuoteQueueApi = async ({dispatch, pageSize = 20, page = 1}) => {
  try {
    dispatch(getMarketingSegmentsQuoteQueueStart());
    const params = new URLSearchParams({
      pageSize: pageSize.toString(),
      page: page.toString(),
    }).toString();

    const { data } = await api.get(`${shopManagerApi}/quotepro-store/marketing-segments/queue?${params}`);
    dispatch(getMarketingSegmentsQuoteQueueSuccess(data));
    return true;
  } catch (e) {
    dispatch(getMarketingSegmentsQuoteQueueFailed(e));
    return false;
  }
};

export const getFailedMarketingSegmentsQuoteQueueApi = async ({dispatch, pageSize = 20, page = 1,}) => {
  try {
    dispatch(getFailedMarketingSegmentsQuoteQueueStart());
    const params = new URLSearchParams({
      status: 'FAILED',
      pageSize: pageSize.toString(),
      page: page.toString(),
    }).toString();

    const { data } = await api.get(`${shopManagerApi}/quotepro-store/marketing-segments/queue?${params}`);
    dispatch(getFailedMarketingSegmentsQuoteQueueSuccess(data));
    return data;
  } catch (e) {
    dispatch(getFailedMarketingSegmentsQuoteQueueFailed(e));
    return null;
  }
};

export const deleteFailedMarketingSegmentQueueTask = async ({dispatch, id}) => {
  try {
    dispatch(deleteFailedMarketingSegmentQueueTasksStart());
    await api.delete(`${shopManagerApi}/quotepro-store/marketing-segments/queue/${id}`);
    dispatch(deleteFailedMarketingSegmentQueueTasksSuccess(id));
    return true;
  } catch (e) {
    dispatch(deleteFailedMarketingSegmentQueueTasksFailed(e));
    return false;
  }
};

export const deleteMarketingSegmentQueueTaskApi = async ({dispatch, id}) => {
  try {
    dispatch(deleteMarketingSegmentQueueTaskStart());
    await api.delete(`${shopManagerApi}/quotepro-store/marketing-segments/queue/${id}`);
    dispatch(deleteMarketingSegmentQueueTaskSuccess(id));
    return true;
  } catch (e) {
    dispatch(deleteMarketingSegmentQueueTaskFailed(e));
    return false;
  }
};

export const getQuoteSubscriptionApi = async ({dispatch, sortField, pageSize, currentPage, filterConditions}) => {
  try {
    dispatch(getCustomerSubscriptionsStart());
    const params = convertToSearchCriteria({
      sortDirection: 'desc',
      sortField,
      pageSize,
      currentPage,
      filterConditions,
      searchConditions: []
    });
    const { data } = await api.get(`${shopManagerApi}/quotepro-store/subscription?${params}`);
    dispatch(getCustomerSubscriptionsSuccess(data));
    return data;
  } catch (e) {
    dispatch(getCustomerSubscriptionsFailed(e));
    return null;
  }
};

export const createQuoteProPackageApi = async ({dispatch, packageData}) => {
  try {
    dispatch(createQuoteProPackageStart());
    const { data } = await api.post(`${shopManagerApi}/quotepro-store/package`, packageData);
    dispatch(createQuoteProPackageSuccess(data));
    return true;
  } catch (e) {
    dispatch(createQuoteProPackageFailed(e));
    return false;
  }
};

export const getQuoteProPackagesApi = async ({
  dispatch,
  name = '',
  sortField = 'createdAt',
  sortDir = 'desc',
  limit = '20',
  page = '1'
}) => {
  try {
    dispatch(getQuoteProPackagesStart());
    const params = new URLSearchParams({
      name: encodeURI(name),
      sortField,
      sortDir,
      limit,
      page
    }).toString();
    const { data } = await api.get(`${shopManagerApi}/quotepro-store/package?${params}`);
    dispatch(getQuoteProPackagesSuccess(data));
    return true;
  } catch (e) {
    dispatch(getQuoteProPackagesFailed(e));
    return false;
  }
};

export const deleteQuoteProPackageApi = async ({ dispatch, id }) => {
  try {
    dispatch(deleteQuoteProPackageStart());
    await api.delete(`${shopManagerApi}/quotepro-store/package/${id}`);
    dispatch(deleteQuoteProPackageSuccess(id));
  } catch (e) {
    dispatch(deleteQuoteProPackageFailed(e));
  }
};

export const getTimezoneConfigApi = async ({dispatch}) => {
  const params = [
    'configs[]=general/locale/timezone'
  ];

  try {
    dispatch(getTimezoneConfigStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?${params.join('&')}`);
    dispatch(getTimezoneConfigSuccess(data));
  } catch (e) {
    dispatch(getTimezoneConfigFailed(e));
  }
};

export const createQuotePdfPreviewApi = async ({dispatch, id, selectedItemsIds = [], quoteNotes,  expirationDate, quoteName, quoteDiscount}) => {
  try {
    dispatch(createQuotePdfPreviewStart());
    const data = await api.post(
      `${shopManagerApi}/push-cart/${id}/preview-pdf`,
      {selectedItemsIds, patient_notice: quoteNotes, expirationDate, quoteName, quoteDiscount}
    );
    dispatch(createQuotePdfPreviewSuccess(data));
  } catch (e) {
    dispatch(createQuotePdfPreviewFailed(e));
  }
};

export const downloadQuotePdfApi = async ({dispatch, id, selectedItemsIds = [], quoteNotes, expirationDate, quoteName, quoteDiscount}) => {
  try {
    dispatch(downloadQuotePdfStart());
    const {data} = await api.post(
      `${shopManagerApi}/push-cart/${id}/download-pdf`,
      {selectedItemsIds, patient_notice: quoteNotes, expirationDate, quoteName, quoteDiscount},
      { responseType: 'blob' }
    );
    const blob = new Blob([data], {type: 'application/pdf'});
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');
    dispatch(downloadQuotePdfSuccess());
  } catch (e) {
    dispatch(downloadQuotePdfFailed(e));
  }
};

export const createDraftQuoteApi = async ({dispatch, pushCartId, pushCart}) => {
  try {
    dispatch(createDraftQuoteStart());
    const {data} = await api.post(`${shopManagerApi}/draft-quote/${pushCartId}`, pushCart);
    dispatch(createDraftQuoteSuccess(data));
    return !data.pushCart.selectedItems.length;
  } catch (e) {
    dispatch(createDraftQuoteFailed(e));
    return false;
  }
};

export const getDraftQuotesByCustomerApi = async ({dispatch, customerId}) => {
  try {
    dispatch(getDraftQuotesByCustomerStart());

    const {data} = await api.get(`${shopManagerApi}/draft-quote/${customerId}`);
    dispatch(getDraftQuotesByCustomerSuccess(data));
  } catch (e) {
    dispatch(getDraftQuotesByCustomerFailed(e));
  }
};

export const openCheckoutServiceForDraftedQuoteApi = async ({dispatch, id, quoteDiscount}) => {
  try {
    dispatch(openCheckoutServiceForDraftedQuoteStart());

    const { data } = await api.post(`${shopManagerApi}/draft-quote/${id}/pay`, { quoteDiscount });
    dispatch(openCheckoutServiceForDraftedQuoteSuccess(data));
  } catch (e) {
    dispatch(openCheckoutServiceForDraftedQuoteFailed(e));
  }
};

export const publishDraftQuoteByIdApi = async ({dispatch, id, quoteNotes, expirationDate, startDate, mustUsedDate, quoteName, quoteDiscount}) => {
  try {
    dispatch(publishDraftQuoteByIdStart());

    const { data } = await api.post(`${shopManagerApi}/draft-quote/${id}/publish`, { patient_notice: quoteNotes, expirationDate,  startDate, mustUsedDate, quoteName, quoteDiscount });
    dispatch(publishDraftQuoteByIdSuccess(data));
  } catch (e) {
    dispatch(publishDraftQuoteByIdFailed(e));
  }
};

export const createDraftQuotePdfPreviewApi = async ({dispatch, id, quoteNotes, expirationDate, startDate, mustUsedDate, quoteName, quoteDiscount}) => {
  try {
    dispatch(createDraftQuotePdfPreviewStart());
    const data = await api.post(`${shopManagerApi}/draft-quote/${id}/preview-pdf`,
      { patient_notice: quoteNotes, expirationDate, startDate, mustUsedDate, quoteName, quoteDiscount });
    dispatch(createDraftQuotePdfPreviewSuccess(data));
  } catch (e) {
    dispatch(createDraftQuotePdfPreviewFailed(e));
  }
};

export const createRecentQuotePdfPreviewApi = async ({dispatch, id, quoteData}) => {
  try {
    dispatch(createRecentQuotePdfPreviewStart());
    const data = await api.post(`${shopManagerApi}/quotepro-store/amasty-quotes/${id}/preview-pdf`, quoteData);
    dispatch(createRecentQuotePdfPreviewSuccess(data));
  } catch (e) {
    dispatch(createRecentQuotePdfPreviewFailed(e));
  }
};

export const downloadRecentQuotePdfApi = async ({dispatch, id, quoteData}) => {
  try {
    dispatch(downloadRecentQuotePdfStart());

    const { data } = await api.post(`${shopManagerApi}/quotepro-store/amasty-quotes/${id}/download-pdf`,
      quoteData,
      { responseType: 'blob' }
    );
    const blob = new Blob([data], {type: 'application/pdf'});
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');

    dispatch(downloadRecentQuotePdfSuccess());
  } catch (e) {
    dispatch(downloadRecentQuotePdfFailed(e));
  }
};

export const downloadDraftQuotePdfApi = async ({dispatch, id, quoteNotes, expirationDate, quoteName, quoteDiscount}) => {
  try {
    dispatch(downloadDraftQuotePdfStart());

    const { data } = await api.post(`${shopManagerApi}/draft-quote/${id}/download-pdf`,
      { patient_notice: quoteNotes, expirationDate, quoteName, quoteDiscount },
      { responseType: 'blob' }
    );
    const blob = new Blob([data], {type: 'application/pdf'});
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');

    dispatch(downloadDraftQuotePdfSuccess());
  } catch (e) {
    dispatch(downloadDraftQuotePdfFailed(e));
  }
};

export const updateDraftQuoteByIdApi = async ({dispatch, updatedDraftQuoteId, updatedDraftQuote}) => {
  try {
    dispatch(updateDraftQuoteByIdStart());
    const {data} = await api.patch(`${shopManagerApi}/draft-quote/${updatedDraftQuoteId}`, updatedDraftQuote);
    dispatch(updateDraftQuoteByIdSuccess(data));
    return data;
  } catch (e) {
    dispatch(updateDraftQuoteByIdFailed(e));
    return null;
  }
};

export const getDealTasksApi = async ({dispatch, dealId}) => {
  try {
    dispatch(getDealTasksStart());
    const { data } = await api.get(`${shopManagerApi}/deal/task/${dealId}`);
    dispatch(getDealTasksSuccess(data, dealId));
  } catch (e) {
    dispatch(getDealTasksFailed(e));
  }
};

export const createDealTasksApi = async ({dispatch, taskData}) => {
  try {
    dispatch(createDealTaskStart());
    const { data } = await api.post(`${shopManagerApi}/deal/task/`, taskData);
    dispatch(createDealTaskSuccess(data));
  } catch (e) {
    dispatch(createDealTaskFailed(e));
  }
};

export const updateDealTasksApi = async ({dispatch, id, taskData}) => {
  try {
    dispatch(updateDealTaskStart());
    const { data } = await api.put(`${shopManagerApi}/deal/task/${id}`, taskData);
    dispatch(updateDealTaskSuccess(data));
  } catch (e) {
    dispatch(updateDealTaskFailed(e));
  }
};

export const deleteDealTasksApi = async ({dispatch, id, dealId}) => {
  try {
    dispatch(deleteDealTaskStart());
    await api.delete(`${shopManagerApi}/deal/task/${id}`);
    dispatch(deleteDealTaskSuccess(id, dealId));
  } catch (e) {
    dispatch(deleteDealTaskFailed(e));
  }
};

export const getDealActivitiesApi = async ({dispatch, dealId}) => {
  try {
    dispatch(getDealActivitiesStart());
    const { data } = await api.get(`${shopManagerApi}/deal/activity/${dealId}`);
    dispatch(getDealActivitiesSuccess(data, dealId));
  } catch (e) {
    dispatch(getDealActivitiesFailed(e));
  }
};

export const createDealActivitiesApi = async ({dispatch, activityData}) => {
  try {
    dispatch(createDealActivityStart());
    const { data } = await api.post(`${shopManagerApi}/deal/activity/`, activityData);
    dispatch(createDealActivitySuccess(data));
  } catch (e) {
    dispatch(createDealActivityFailed(e));
  }
};

export const updateDealActivitiesApi = async ({dispatch, id, activityData}) => {
  try {
    dispatch(updateDealActivityStart());
    const { data } = await api.put(`${shopManagerApi}/deal/activity/${id}`, activityData);
    dispatch(updateDealActivitySuccess(data));
  } catch (e) {
    dispatch(updateDealActivityFailed(e));
  }
};

export const deleteDealActivityApi = async ({dispatch, id, dealId}) => {
  try {
    dispatch(deleteDeAlactivityStart());
    await api.delete(`${shopManagerApi}/deal/activity/${id}`);
    dispatch(deleteDealActivitySuccess(id, dealId));
  } catch (e) {
    dispatch(deleteDealActivityFailed(e));
  }
};

export const getAllTasksApi = async ({dispatch, email = '', subject = '', type = '', status = '', priority = '', sortField = 'createdAt', sortDir = 'desc', page = '1', limit = '1000' }) => {
  try {
    dispatch(getAllTasksStart());
    const params = new URLSearchParams({
      email,
      subject,
      status,
      type,
      sortField,
      sortDir,
      priority,
      page,
      limit
    }).toString();
    const {data} = await api.get(`${shopManagerApi}/deal/tasks?${params}`);
    dispatch(getAllTasksSuccess(data));
  } catch (e) {
    dispatch(getAllTasksFailed(e));
  }
};

export const getAllActivitiesApi = async ({dispatch, email = '', subject = '', type = '', notes = '', sortField = 'createdAt', sortDir = 'desc', page = '1', limit = '1000' }) => {
  try {
    dispatch(getAllActivitiesStart());
    const params = new URLSearchParams({
      email,
      subject,
      type,
      notes,
      sortField,
      sortDir,
      page,
      limit
    }).toString();
    const {data} = await api.get(`${shopManagerApi}/deal/activities?${params}`);
    dispatch(getAllActivitiesSuccess(data));
  } catch (e) {
    dispatch(getAllActivitiesFailed(e));
  }
};

export const cancelQuoteApi = async ({ dispatch, quoteId }) => {
  try {
    dispatch(cancelQuoteStart());
    await api.post(`${shopManagerApi}/quotepro-store/proxy`, {
      path: '/V1/quotepro/quotes/bulk-update-status',
      method: 'POST',
      query_parameters: {},
      body: {
        ids: [quoteId],
        status: 4
      }
    });
    dispatch(cancelQuoteSuccess(quoteId));
  } catch (e) {
    dispatch(cancelQuoteFailed(e));
  }
};
